"use client"

import ChatInterface from "@/components/chat/ChatInterface"
import { GlobalContextProvider } from "@/app/context/GlobalContext"

export default function ChatPage() {
  return (
    <GlobalContextProvider>
      <div className="relative h-screen">
        <ChatInterface />
      </div>
    </GlobalContextProvider>
  )
}
